// @flow
import { Base } from '@gandi/ui';

import styles from './RestrictionBlock.scss';

type Props = {
  restriction: string,
};

export function RestrictionBlock({ restriction }: Props): React.MixedElement {
  return (
    <div className={styles.root}>
      <Base
        margin="none"
        color="weak"
        dangerouslySetInnerHTML={{ __html: restriction }}
      />
    </div>
  );
}
